import { uploadFileToS3 } from "../utils/uploadFileToS3";
import { getCDN } from "../utils/consts";
import { getRoot } from "mobx-state-tree";
import { RootInstance } from "../root";
import { compress } from "@blings/blings-player";
import { analyticsInstance } from "../../analytics/analyticsCtrls";

export async function uploadJsonToVideoPart(videoPartName: any, self: any) {
  const fileName = Date.now() + "_" + self.jsonFileName;
  const compressedJson = compress(self.compJson);
  try {
    const res = await uploadFileToS3(
      self.platformStorageProjectAssetsRoot + `/${fileName}`,
      {
        stringData: compressedJson,
      }
    );
    await getRoot<RootInstance>(self).projectStore.updateProjectVideoPart(
      videoPartName,
      self.hasVideo,
      `${getCDN()}/${res.key as string}`,
      self.uploadedFonts
    );
    analyticsInstance.sendAnalytics("render", {
      val: "success",
      sceneName: videoPartName,
    });
  } catch (error) {
    throw new Error("Failed to upload json to video part"); // TODO add this ui
  }
}
